import React from 'react';
import { connect } from 'react-redux'
import { Card, Button, Table } from 'antd'
import {
    chageModal,
    openModal,
    destroyBrothersMember
} from "../../../actions";
import {
    updateApplicationForAdmission
} from "../../../actions";

const { Column } = Table;

class BrothersMembersData extends React.Component {
    render() {
        return (
            <Card title="在校生兄姐">
                <p style={{color: 'red', fontWeight: 'bold'}}>現在就讀班級與姓名</p>
                <BrothersMemberView borthersMembers={this.props.borthersMembers} destroy={this.destroy} />
                <Button type={'primary'} size={'large'} onClick={this.brothersMembersButton} style={{ width: '100%', marginTop: '10px', backgroundColor: 'gray' }}>
                    增加
                </Button>
            </Card>
        )
    }


    brothersMembersButton = () => {
        this.props.openModal('brothers_members_modal')
    }

    destroy = (id) => {
        this.props.destroyBrothersMember(id)
    }
}

function isIterable(obj) {
    return obj != null && typeof obj[Symbol.iterator] === 'function';
}


const BrothersMemberView = props => {
    let { borthersMembers, destroy } = props
    console.log("isIterable:"+borthersMembers.size !== 0);
    console.log("borthersMembers:"+borthersMembers);


    if (borthersMembers.size !== 0) {
        return (
            <Table dataSource={borthersMembers.valueSeq().toJSON()}>
                <Column
                    title="班級"
                    dataIndex="stud_brothers_class"
                    key="stud_brothers_class"
                />
                <Column
                    title="姓名"
                    dataIndex="stud_brothers_name"
                    key="stud_brothers_name"
                />
                <Column
                    title="功能"
                    key="action"
                    render={(text, record) => (
                        <Button onClick={() => destroy(record.key)} size={'small'}>
                            刪除
                        </Button>
                    )}
                />
            </Table>
        )
    } else {
        return false
    }

}

const mapStateToProps = (state) => {
    return {
        applicationForAdmission: state.getIn(['form']),
        borthersMembers: state.getIn(['BrothersMember', 'index_data']),
    }
}
const mapDispatchToPorps = (dispatch) => ({
    openModal: (payload) => (
        dispatch(openModal(payload))
    ),
    chageModal: (payload) => (
        dispatch(chageModal(payload))
    ),
    destroyBrothersMember: (payload) => (
        dispatch(destroyBrothersMember(dispatch, payload))
    ),
    updateApplicationForAdmission: (payload) => (
        dispatch(updateApplicationForAdmission(dispatch, payload))
    ),
})

export default connect(mapStateToProps, mapDispatchToPorps)(BrothersMembersData)



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ApplicationForAdmissionContaioner/NewStudentForm/BrothersMembersData.jsx